import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { OnDemandPickupAddress } from 'src/app/core/models/operations/on-demand-pickup-address.model';
import { OnDemandPickup } from 'src/app/core/models/operations/operations-on-demand-pickup.model';
import { PICKUP_ADDRESS_CONSTANTS } from '../current-pickup-section/current-pickup-section.constants';
import { CONSTANTS } from './address-section.constants';

@Component({
  selector: 'app-address-section',
  templateUrl: './address-section.component.html',
  styleUrls: ['./address-section.component.scss'],
  standalone: false,
})
export class AddressSectionComponent {
  private readonly dialog = inject(MatDialog);

  @ViewChild('numberOfPackagesDialog')
  numberOfPackagesDialog!: TemplateRef<unknown>;

  @Input() data!: OnDemandPickupAddress;
  @Input() form!: FormGroup;
  @Input() events!: Observable<void>;
  @Input() uncheckEvent!: Observable<void>;
  @Output() formUpdateEvent = new EventEmitter<OnDemandPickup>();

  readonly HEADER = CONSTANTS;
  readonly CONSTS = PICKUP_ADDRESS_CONSTANTS;

  packageSearchText = '';

  get filteredPackageList(): string[] {
    const packageCount = Number(this.data?.numberofPkgs ?? 0);
    const normalizedSearch = this.packageSearchText.trim().toLowerCase();

    const packageList = Array.from({ length: packageCount }, (_, index) =>
      `${this.data?.slic ?? ''}${this.data?.postalCode ?? ''}-${String(index + 1).padStart(3, '0')}`,
    );

    if (!normalizedSearch) {
      return packageList;
    }

    return packageList.filter((item) =>
      item.toLowerCase().includes(normalizedSearch),
    );
  }

  onClickNumberOfPackages(): void {
    this.packageSearchText = '';
    this.dialog.open(this.numberOfPackagesDialog, {
      width: '620px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'number-of-packages-panel',
    });
  }

  closeNumberOfPackagesPanel(): void {
    this.dialog.closeAll();
  }
}
